import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {    
    WHITE_FONT_COLOR,
    FONT_FAMILY_DEMI,
    BASE_TEXT_PX,
    DARK_GRAY_FONT_COLOR,
} from 'src/styles/fonts/MCFontConstants';
const PANEL_BUTTON_WIDTH = '100%';
const PANEL_BUTTON_HEIGHT = 'auto';
const BUTTON_DISABLED_BG_COLOR = '#ebebeb';
const PANEL_BUTTON_BORDER = `1px solid ${BUTTON_DISABLED_BG_COLOR}`;
const PANEL_BUTTON_BORDER_RADIUS= '6px';
export const PanelButton = styled.button`
    width: ${(props) => props.width || PANEL_BUTTON_WIDTH };
    height: ${(props) => props.height || PANEL_BUTTON_HEIGHT};
    background-color: ${(props) =>
        props.disabled
            ? BUTTON_DISABLED_BG_COLOR
            : props.backgroundColor || WHITE_FONT_COLOR};
    border: ${(props) => props.border || PANEL_BUTTON_BORDER};
    font-family: ${(props) => props.fontFamily || FONT_FAMILY_DEMI};
    font-size: ${(props) => props.fontSize || BASE_TEXT_PX};
    color: ${(props) => props.color || DARK_GRAY_FONT_COLOR};
    border-radius: ${(props) => props.borderRadius || PANEL_BUTTON_BORDER_RADIUS};
    margin: ${(props) => props.margin};
    padding: ${(props) => props.padding};
    justify-content: center;
    align-items: center;
    &:hover {
        background: ${BUTTON_DISABLED_BG_COLOR};
    }
    ${media.mobileDevice`
        width: auto;
        max-width: 100%;
        &:hover {
            background: ${(props) => props.backgroundColor || WHITE_FONT_COLOR};
        }
        background-color: ${(props) => props.backgroundColor || WHITE_FONT_COLOR};
        border: ${(props) => props.border || PANEL_BUTTON_BORDER};
    `}
`;